import {
  LIST_MCU_PROJECT_CRS_REQUEST,
  LIST_MCU_PROJECT_CRS_SUCCESS,
  LIST_MCU_PROJECT_CRS_FAIL,
  LIST_MCU_PROJECT_CRS_SUMMARY_REQUEST,
  LIST_MCU_PROJECT_CRS_SUMMARY_SUCCESS,
  LIST_MCU_PROJECT_CRS_SUMMARY_FAIL,
  CREATE_MCU_PROJECT_CRS_REQUEST,
  CREATE_MCU_PROJECT_CRS_SUCCESS,
  CREATE_MCU_PROJECT_CRS_FAIL,
  DETAIL_MCU_PROJECT_CRS_REQUEST,
  DETAIL_MCU_PROJECT_CRS_SUCCESS,
  DETAIL_MCU_PROJECT_CRS_FAIL,
  UPDATE_MCU_PROJECT_CRS_REQUEST,
  UPDATE_MCU_PROJECT_CRS_SUCCESS,
  UPDATE_MCU_PROJECT_CRS_FAIL,
  DELETE_MCU_PROJECT_CRS_REQUEST,
  DELETE_MCU_PROJECT_CRS_SUCCESS,
  DELETE_MCU_PROJECT_CRS_FAIL,
  RESET_MCU_PROJECT_CRS
} from '../../constants/mcu-project-crs'

const initialState = {
  loading: false,
  loadingDelete: false,
  loadingCreate: false,
  mcuProjectProperties: [],
  mcuProjectProperty: {},
  error: null,
  pageable: {
    page: 1,
    size: 10
  }
}

const mcuProjectReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_MCU_PROJECT_CRS_REQUEST:
      return { ...state, loading: true }
    case LIST_MCU_PROJECT_CRS_SUCCESS:
      return {
        ...state,
        loading: false,
        mcuProjectProperties: action.payload,
        pageable: action.pageable
      }
    case LIST_MCU_PROJECT_CRS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        mcuProjectProperties: action?.dummy
      }
    case LIST_MCU_PROJECT_CRS_SUMMARY_REQUEST:
      return { ...state, loading: true }
    case LIST_MCU_PROJECT_CRS_SUMMARY_SUCCESS:
      return { ...state, loading: false, mcuProjectProperties: action.payload }
    case LIST_MCU_PROJECT_CRS_SUMMARY_FAIL:
      return { ...state, loading: false, error: action.payload }
    case CREATE_MCU_PROJECT_CRS_REQUEST:
      return { ...state, loadingCreate: true }
    case CREATE_MCU_PROJECT_CRS_SUCCESS:
      return { ...state, loadingCreate: false }
    case CREATE_MCU_PROJECT_CRS_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case DETAIL_MCU_PROJECT_CRS_REQUEST:
      return { ...state, loadingCreate: true, mcuProjectProperty: {} }
    case DETAIL_MCU_PROJECT_CRS_SUCCESS:
      return {
        ...state,
        loadingCreate: false,
        mcuProjectProperty: action.payload
      }
    case DETAIL_MCU_PROJECT_CRS_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case UPDATE_MCU_PROJECT_CRS_REQUEST:
      return { ...state, loadingCreate: true }
    case UPDATE_MCU_PROJECT_CRS_SUCCESS:
      return { ...state, loadingCreate: false }
    case UPDATE_MCU_PROJECT_CRS_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case DELETE_MCU_PROJECT_CRS_REQUEST:
      return { ...state, loadingDelete: true }
    case DELETE_MCU_PROJECT_CRS_SUCCESS:
      return { ...state, loadingDelete: false }
    case DELETE_MCU_PROJECT_CRS_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }
    case RESET_MCU_PROJECT_CRS:
      return { ...state, loading: false, error: null }
    default:
      return state
  }
}

export default mcuProjectReducer
